import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';

/**
 * Guards a route: while the initial auth check is in flight it shows a spinner,
 * then either renders the children or redirects to /login (remembering where the
 * user was going so Login can send them back).
 */
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Ładowanie…</span>
                </Spinner>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location }} />;
    }

    return children;
};

export default ProtectedRoute;
